import { Colors } from '@/types/store';
import { create } from 'zustand';
import { PreviewSize } from '../constants/editorThemeConstants';
import { useCustomizationStore } from './customizationStore';

export interface ThemeEditorStore {
    previewSize: PreviewSize;
    menuOpen: boolean;
    customColors: Colors | null;
    editBlockId: number | string | null;
    errorBlockId: number | string | null;

    setPreviewSize: (previewSize: PreviewSize) => void;
    setMenuOpen: (menuOpen: boolean) => void;
    setCustomColors: (customColors: Colors | null) => void;
    setEditBlockId: (editBlockId: number | string | null) => void;
    setErrorBlockId: (errorBlockId: number | string | null) => void;
}

export const useThemeEditorStore = create<ThemeEditorStore>(set => ({
    previewSize: PreviewSize.DESKTOP,
    menuOpen: false,
    customColors: null,
    editBlockId: null,
    errorBlockId: null,

    setPreviewSize: (previewSize: PreviewSize) => set({ previewSize }),
    setMenuOpen: (menuOpen: boolean) => set({ menuOpen }),
    setCustomColors: (customColors: Colors | null) => set({ customColors }),
    setEditBlockId: (editBlockId: number | string | null) => set({ editBlockId }),
    setErrorBlockId: (errorBlockId: number | string | null) => {
        set({ errorBlockId });
        setTimeout(() => set({ errorBlockId: null }), 5000); // Reset error block id after timeout
    },
}));

// Auto-cleanup pending blocks when menu closes
// This subscription runs automatically when the module is loaded
let previousMenuOpen = true;

useThemeEditorStore.subscribe(state => {
    const currentMenuOpen = state.menuOpen;
    // Only remove blocks when transitioning from open to closed
    if (!currentMenuOpen && previousMenuOpen) {
        useCustomizationStore.getState().clearPendingItems();
    }
    previousMenuOpen = currentMenuOpen;
});
